import { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { viewImage } from '../../CommonUtils/viewImage';
import { BsFiletypePdf } from 'react-icons/bs';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FaDownload } from 'react-icons/fa';
import { openPdfInNewTab } from '../../CommonUtils/CommonServices';
export default function Affl_CdcReport2022() {
    const acYear = sessionStorage.getItem('ac_year');
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const handleNavigate = (collCode, instname, type) => {
        navigate('/AfflOrdVerif2021', {
            state: { type, instname, collCode }
        });
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    };
    const ProeedConfirmdetailsFormik = useFormik({
        initialValues: {
            acYear: acYear,
        },
        onSubmit: (values) => {

        },
    })
    const [cdcengData22, setCdcengData22] = useState([]);
    function GetCdcEnggReport() {
        let url = config.url.API_URL + `cdcNonOamdcReport `;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setCdcengData22(res?.data?.cdcNonOamdcReport)

            } else {
                setCdcengData22([])

            }
        })
    }



    function GetDeficienciesPdf(collCode) {
        let url = config.url.API_URL + `getafflfacultydef/pdf/` + collCode + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === 1) {
                openPdfInNewTab(res?.data?.data)
            } else {
                console.log("No Data Found")

            }
        })
    }
    useEffect(() => {
        GetCdcEnggReport();
    }, [])

    const CourseDataReportColumns22 = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        { Header: "College Code", accessor: "coll_code", },
        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            )
        },
        {
            Header: "FFCA Deficiencies",
            accessor: '',
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetDeficienciesPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }
        },

        {
            Header: "College Details Confirmation", accessor: "cdc_confirm",
            Cell: ({ row }) => {
                const value = row?.values?.cdc_confirm;
                if (value === "College Details Confirmation") {
                    return <button type='button' className='btn btn-primary rounded-pill btn-sm' onClick={() => { handleNavigate(row?.original?.coll_code, row?.original?.inst_name, "NONOAMDC") }}>  Confirm College Details</button>;
                }
                else {
                    return (
                        <button type="button" className="btn btn  btn-md pt-1"
                            onClick={() => { viewImage(value); }}>
                            <BsFiletypePdf color="red"
                                size={20} />
                        </button>
                    );
                }
            }
        },
    ]

    return (

        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
            <FormikProvider value={ProeedConfirmdetailsFormik}>
                <Form onChange={ProeedConfirmdetailsFormik?.handleChange} onSubmit={ProeedConfirmdetailsFormik?.handleSubmit} className="form_adjust" >
                    <bie.Row className="px-2 my-3">
                        <CommonFormHeading heading={`College Details Confirmation-${acYear}`} />
                        {cdcengData22?.length > 0 ? (
                            <div className="table-responsive">
                                <CommonReactTable data={cdcengData22} columns={CourseDataReportColumns22} pagination="false" filename="AffiliationCdcReport" headerName={`AffiliationCdcReport`} />
                            </div>
                        ) : <center className='text-danger h5 pt-5'>***** No Data Found *****</center>}
                    </bie.Row>
                </Form>
            </FormikProvider>
        </bie.Container>

    )
}
